// Display reference for a decision, e.g. MSR-DEC-261002-A3F9. Derived from the decision's
// creation date and id, so it is stable and needs no extra column; it is a label, not a key.
export function decisionRef(id: string, createdAt: string | null): string {
  const d = createdAt ? new Date(createdAt) : new Date(0);
  const yy = String(d.getUTCFullYear()).slice(2);
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `MSR-DEC-${yy}${mm}${dd}-${id.replace(/-/g, '').slice(0, 4).toUpperCase()}`;
}
